import { LayoutGrid, Headphones, Package, Briefcase, ListChecks, ShieldCheck, Globe, type LucideIcon } from 'lucide-react'
import type { ChangeModule, ChangeType } from '@/changelog'

export const TYPE_META: Record<ChangeType, { label: string; className: string }> = {
  new:      { label: 'New',      className: 'bg-brand-500/10 text-brand-500 border-brand-500/20' },
  improved: { label: 'Improved', className: 'bg-violet-500/10 text-violet-500 border-violet-500/20' },
  fixed:    { label: 'Fixed',    className: 'bg-status-success/10 text-status-success border-status-success/20' },
}

export const MODULE_META: Record<ChangeModule, { label: string; icon: LucideIcon }> = {
  general:  { label: 'General',         icon: LayoutGrid },
  helpdesk: { label: 'Helpdesk',        icon: Headphones },
  assets:   { label: 'Assets',          icon: Package },
  business: { label: 'Business',        icon: Briefcase },
  work:     { label: 'Work Management', icon: ListChecks },
  admin:    { label: 'Admin',           icon: ShieldCheck },
  platform: { label: 'Platform',        icon: Globe },
}

export function formatReleaseDate(date: string) {
  return new Date(`${date}T00:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
}
